import React, { useState, useEffect } from 'react';
import BedCard from '../components/BedCard';
// import { Timeline } from '../components/ui/timeline'; // Removed
import { getBeds, updateBedStatus } from '../services/api';
import { getStatuses } from '../services/api';
import { getSectors } from '../services/api';

const BedManagement = () => {
  const [beds, setBeds] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [filterSector, setFilterSector] = useState('');
  const [filterStatusCategory, setFilterStatusCategory] = useState('');
  const [filterStatus, setFilterStatus] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const bedsResponse = await getBeds();
        const statusesResponse = await getStatuses();
        const sectorsResponse = await getSectors();

        setBeds(bedsResponse.data);
        setStatuses(statusesResponse.data);
        setSectors(sectorsResponse.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const handleStatusChange = async (bedId, newStatusId, notes) => {
    try {
      const response = await updateBedStatus(bedId, newStatusId, notes);
      setBeds(beds.map(bed => bed.id === bedId ? response.data : bed));
    } catch (error) {
      console.error('Error updating bed status:', error);
      alert('Erro ao atualizar status do leito');
    }
  };

  // Filtrar leitos
  const filteredBeds = beds.filter(bed => {
    const sectorMatch = !filterSector || bed.sectorId === parseInt(filterSector);
    const status = statuses.find(s => s.id === bed.statusId);
    const categoryMatch = !filterStatusCategory || status?.category === filterStatusCategory;
    const statusMatch = !filterStatus || bed.statusId === parseInt(filterStatus);

    return sectorMatch && categoryMatch && statusMatch;
  });

  // Accordion State
  const [expandedSectorId, setExpandedSectorId] = useState(null);

  const toggleSector = (sectorId) => {
    if (expandedSectorId === sectorId) {
      setExpandedSectorId(null);
    } else {
      setExpandedSectorId(sectorId);
    }
  };

  // Calcular setores ativos (Movido para escopo principal para corrigir ReferenceError)
  const activeSectors = sectors.map(sector => {
    const sectorBeds = filteredBeds.filter(bed => bed.sectorId === sector.id);

    // Se filtro de status/categoria estiver ativo e não houver leitos neste setor, esconder setor
    if ((filterStatus || filterStatusCategory) && sectorBeds.length === 0) return null;

    // Se nenhum filtro, mostrar todos os setores (mas usamos filtro vazio para manter consistente)
    if (sectorBeds.length === 0 && !filterSector) return { ...sector, beds: [] };
    if (sectorBeds.length === 0) return null;

    return { ...sector, beds: sectorBeds };
  }).filter(Boolean);

  // Renderizar (Accordion Style)
  const renderSectorAccordion = () => {
    return (
      <div className="space-y-4 max-w-7xl mx-auto px-4 pb-20">
        <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-6">
          Leitos por Setor
        </h2>

        {activeSectors.map(sector => (
          <div key={sector.id} className="bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden border border-gray-200 dark:border-gray-700">
            <button
              onClick={() => toggleSector(sector.id)}
              className="w-full flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 transition-colors"
            >
              <div className="flex items-center gap-3">
                <div className={`w-3 h-10 rounded-full ${expandedSectorId === sector.id ? 'bg-blue-600' : 'bg-gray-400'}`}></div>
                <div className="text-left">
                  <h3 className="text-lg font-bold text-gray-800 dark:text-white">{sector.name}</h3>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {sector.beds.length} leitos • {sector.beds.filter(b => b.statusId === 1).length} livres
                  </p>
                </div>
              </div>

              <div className={`transform transition-transform duration-200 ${expandedSectorId === sector.id ? 'rotate-180' : ''}`}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            </button>

            {/* Conteúdo (Leitos) - Só renderiza se expandido */}
            {expandedSectorId === sector.id && (
              <div className="p-4 bg-white dark:bg-gray-900 border-t border-gray-100 dark:border-gray-800 animate-fadeIn">
                {sector.beds.length > 0 ? (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4">
                    {sector.beds.map(bed => (
                      <BedCard
                        key={bed.id}
                        bed={bed}
                        sectors={sectors}
                        statuses={statuses}
                        onStatusChange={handleStatusChange}
                      />
                    ))}
                  </div>
                ) : (
                  <p className="text-gray-500 text-center py-4">Nenhum leito neste setor com os filtros atuais.</p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="w-full pb-safe">
      <div className="max-w-7xl mx-auto px-4 md:px-8 mt-4 mb-8">
        <div className="row g-3">
          <div className="col-12 col-md-4">
            <label className="form-label font-semibold text-gray-700">Filtrar por Setor</label>
            <select
              className="form-select shadow-sm"
              value={filterSector}
              onChange={(e) => setFilterSector(e.target.value)}
            >
              <option value="">Todos</option>
              {sectors.map(sector => (
                <option key={sector.id} value={sector.id}>{sector.name}</option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label font-semibold text-gray-700">Filtrar por Categoria</label>
            <select
              className="form-select shadow-sm"
              value={filterStatusCategory}
              onChange={(e) => setFilterStatusCategory(e.target.value)}
            >
              <option value="">Todas</option>
              <option value="Disponível">Disponível</option>
              <option value="Reservado">Reservado</option>
              <option value="Bloqueado">Bloqueado</option>
            </select>
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label font-semibold text-gray-700">Filtrar por Status</label>
            <select
              className="form-select shadow-sm"
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="">Todos</option>
              {statuses.map(status => (
                <option key={status.id} value={status.id}>{status.name}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {filteredBeds.length === 0 && activeSectors.length === 0 ? (
        <div className="alert alert-info max-w-4xl mx-auto mx-4">
          Nenhum leito encontrado com os filtros selecionados.
        </div>
      ) : (
        renderSectorAccordion()
      )}
    </div>
  );
};

export default BedManagement;
